import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { API_URL } from "../consts";
import { Risorse, RisorseTipologie } from "../prismaTypes";
import EditIcon from "@mui/icons-material/Edit";
import { Link as RouterLink } from "react-router-dom";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";

export function TabellaRisorseClub() {
  const { isLoading, data } = useQuery<
    unknown,
    AxiosError,
    { risorse: (Risorse & { tipologia: RisorseTipologie })[] }
  >(["risorse/findAll"], () => axios.get(API_URL + "risorse/findAll").then((res) => res.data));

  if (isLoading) return <>Loading...</>;

  if (!data) return <></>;
  if (!("risorse" in data)) return <></>;

  return (
    <Table size="small" aria-label="purchases">
      <TableHead>
        <TableRow>
          <TableCell></TableCell>
          <TableCell>Risorse</TableCell>
          <TableCell>Nome</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.risorse
          ?.filter((r) => r.attiva && r.tipologia !== null)
          .map((risorsa) => (
            <TableRow key={risorsa.id}>
              <TableCell>
                <Link to={"/app/editRisorsa/" + risorsa.id} underline="none" component={RouterLink}>
                  <IconButton sx={{ p: 0 }}>
                    <EditIcon />
                  </IconButton>
                </Link>
              </TableCell>
              <TableCell>{risorsa.tipologia.definizione}</TableCell>
              <TableCell>{risorsa.denominazione}</TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}
